// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-page {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Noto Sans KR', sans-serif;
    color: #333;
}

.cp-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.cp-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.cp-main-title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}

.cp-progress-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    padding: 20px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.cp-progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ccc;
    font-size: 14px;
    width: 150px;
    text-align: center;
}

.cp-progress-step.active {
    color: #E84100;
    font-weight: bold;
}

.cp-step-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ccc;
    margin-bottom: 10px;
    border: 2px solid #ccc;
}

.cp-progress-step.active .cp-step-dot {
    background-color: #E84100;
    border-color: #E84100;
}

.cp-progress-line {
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    max-width: 200px;
}

.cp-step-container {
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cp-form-grid {
    width: 100%;
    border-top: 2px solid #333;
    border-bottom: 1px solid #ccc;
    display: table;
    border-spacing: 0;
}

.cp-form-row {
    display: table-row;
}

.cp-form-row label {
    font-weight: bold;
    padding: 20px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #eee;
    display: table-cell;
    width: 200px;
    vertical-align: middle;
}

.cp-form-field {
    padding: 10px 20px;
    border-bottom: 1px solid #eee;
    display: table-cell;
    vertical-align: middle;
}

.cp-form-field input[type="password"] {
    width: 100%;
    max-width: 350px;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.cp-form-field.static {
    font-weight: bold;
}

.cp-notes {
    align-self: flex-start;
    margin-left: calc(200px + 20px);
    margin-top: 15px;
}

.cp-notes ul {
    list-style-type: '• ';
    padding-left: 20px;
    font-size: 14px;
    color: #888;
    line-height: 1.6;
}

.cp-actions {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    width: 100%;
}

.cp-confirm-btn {
    width: 100%;
    max-width: 400px;
    padding: 15px;
    font-size: 16px;
    background-color: #E84100;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
}

.cp-step-container.centered-content {
    text-align: center;
    padding: 60px 0;
}

.cp-final-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 40px;
}

.cp-home-btn {
    padding: 15px 40px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .change-password-page {
        margin: 20px auto;
    }

    .cp-main-title {
        font-size: 28px;
    }

    .cp-form-row label {
        width: 150px;
    }

    .cp-notes {
        margin-left: calc(150px + 20px);
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .change-password-page {
        padding: 0 15px;
        margin: 15px auto;
    }

    .cp-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .cp-main-title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .cp-progress-bar {
        display: none;
    }

    .cp-form-grid,
    .cp-form-row,
    .cp-form-row label,
    .cp-form-field {
        display: block;
        width: 100%;
    }

    .cp-form-row label {
        background-color: transparent;
        padding: 10px 0;
        border-bottom: none;
        font-size: 15px;
    }

    .cp-form-field {
        padding: 5px 0 15px 0;
        border-bottom: 1px solid #eee;
    }
    
    .cp-form-grid {
        border: none;
    }
    
    .cp-form-row:last-child .cp-form-field {
        border-bottom: none;
    }

    .cp-form-field input[type="password"] {
        max-width: 100%;
        height: 45px;
    }

    .cp-notes {
        margin-left: 0;
        margin-top: 10px;
    }

    .cp-notes ul {
        padding-left: 15px;
        font-size: 13px;
    }

    .cp-actions {
        margin-top: 30px;
    }

    .cp-confirm-btn {
        max-width: 100%;
    }
    
    .cp-step-container.centered-content {
        padding: 40px 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/ChangePasswordPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;;QAII,cAAc;QACd,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,6BAA6B;IACjC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".change-password-page {\n    max-width: 1200px;\n    margin: 40px auto;\n    padding: 0 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n    color: #333;\n}\n\n.cp-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.cp-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.cp-main-title {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.cp-progress-bar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 50px;\n    padding: 20px 0;\n    border-top: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.cp-progress-step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ccc;\n    font-size: 14px;\n    width: 150px;\n    text-align: center;\n}\n\n.cp-progress-step.active {\n    color: #E84100;\n    font-weight: bold;\n}\n\n.cp-step-dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: #ccc;\n    margin-bottom: 10px;\n    border: 2px solid #ccc;\n}\n\n.cp-progress-step.active .cp-step-dot {\n    background-color: #E84100;\n    border-color: #E84100;\n}\n\n.cp-progress-line {\n    flex-grow: 1;\n    height: 2px;\n    background-color: #ccc;\n    max-width: 200px;\n}\n\n.cp-step-container {\n    max-width: 900px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.cp-form-grid {\n    width: 100%;\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ccc;\n    display: table;\n    border-spacing: 0;\n}\n\n.cp-form-row {\n    display: table-row;\n}\n\n.cp-form-row label {\n    font-weight: bold;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-bottom: 1px solid #eee;\n    display: table-cell;\n    width: 200px;\n    vertical-align: middle;\n}\n\n.cp-form-field {\n    padding: 10px 20px;\n    border-bottom: 1px solid #eee;\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.cp-form-field input[type=\"password\"] {\n    width: 100%;\n    max-width: 350px;\n    padding: 10px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.cp-form-field.static {\n    font-weight: bold;\n}\n\n.cp-notes {\n    align-self: flex-start;\n    margin-left: calc(200px + 20px);\n    margin-top: 15px;\n}\n\n.cp-notes ul {\n    list-style-type: '• ';\n    padding-left: 20px;\n    font-size: 14px;\n    color: #888;\n    line-height: 1.6;\n}\n\n.cp-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    width: 100%;\n}\n\n.cp-confirm-btn {\n    width: 100%;\n    max-width: 400px;\n    padding: 15px;\n    font-size: 16px;\n    background-color: #E84100;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 20px;\n}\n\n.cp-step-container.centered-content {\n    text-align: center;\n    padding: 60px 0;\n}\n\n.cp-final-title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 40px;\n}\n\n.cp-home-btn {\n    padding: 15px 40px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .change-password-page {\n        margin: 20px auto;\n    }\n\n    .cp-main-title {\n        font-size: 28px;\n    }\n\n    .cp-form-row label {\n        width: 150px;\n    }\n\n    .cp-notes {\n        margin-left: calc(150px + 20px);\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .change-password-page {\n        padding: 0 15px;\n        margin: 15px auto;\n    }\n\n    .cp-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .cp-main-title {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .cp-progress-bar {\n        display: none;\n    }\n\n    .cp-form-grid,\n    .cp-form-row,\n    .cp-form-row label,\n    .cp-form-field {\n        display: block;\n        width: 100%;\n    }\n\n    .cp-form-row label {\n        background-color: transparent;\n        padding: 10px 0;\n        border-bottom: none;\n        font-size: 15px;\n    }\n\n    .cp-form-field {\n        padding: 5px 0 15px 0;\n        border-bottom: 1px solid #eee;\n    }\n    \n    .cp-form-grid {\n        border: none;\n    }\n    \n    .cp-form-row:last-child .cp-form-field {\n        border-bottom: none;\n    }\n\n    .cp-form-field input[type=\"password\"] {\n        max-width: 100%;\n        height: 45px;\n    }\n\n    .cp-notes {\n        margin-left: 0;\n        margin-top: 10px;\n    }\n\n    .cp-notes ul {\n        padding-left: 15px;\n        font-size: 13px;\n    }\n\n    .cp-actions {\n        margin-top: 30px;\n    }\n\n    .cp-confirm-btn {\n        max-width: 100%;\n    }\n    \n    .cp-step-container.centered-content {\n        padding: 40px 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
